import Vue            from 'vue'
import Vuetify        from 'vuetify/lib'
import en             from 'vuetify/es5/locale/en'
import synthesisTheme from './synthesisTheme'

Vuetify.config.silent = process.env.NODE_ENV === 'production' || false

Vue.use(Vuetify)

export default new Vuetify({
  rtl  : false,
  theme: {
    disable: false,
    dark   : false,
    default: 'light',
    options: {
      cspNonce        : undefined,
      minifyTheme     : undefined,
      themeCache      : undefined,
      customProperties: true,
      variations      : true
    },
    themes: {
      light: {
        anchor   : '#2196F3',
        primary  : '#1976D2',
        secondary: '#424242',
        accent   : '#82B1FF',
        error    : '#FF5252',
        info     : '#2196F3',
        success  : '#4CAF50',
        warning  : '#FB8C00',
        ...synthesisTheme
      }
    }
  },
  lang: {
    current: process.env.VUE_APP_I18N_LOCALE,
    locales: {
      en
    }
  },
  icons: {
    iconfont: 'mdi',
    values  : {}
  },
  breakpoint: {
    mobileBreakpoint: 1264,
    scrollBarWidth  : 16,
    thresholds      : {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920
    }
  }
})
